// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".import-org-cert-dialog.common-dialog[data-v-2abf7f44] .el-dialog{width:var(--common-dialog-width)}.import-org-cert-dialog.common-dialog .el-form[data-v-2abf7f44]{margin-right:var(--base-font-size-common)}", ""]);
// Exports
module.exports = exports;
